import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import FocusedTask from '@atlassian/focused-task';
import { isFreeApp } from '@atlassian/mpac-api-client';
import { FocusedTaskErrorBoundaryFallback, resolveInstallationCTALabel, TwoClickAppInstallError, TwoClickAppInstallLoading } from '@atlassian/mpac-installation';
import { ErrorBoundary } from '@atlassian/mpac-ui';
import { useState } from 'react';
import { IntlProvider } from 'react-intl-next';
import { INSTALLABLE_APP_DEFAULT_INSTALL_MODE } from '../../../records/InstallMode/InstallableAppDefaultInstallMode';
import { TEST_IDS } from './constants';
import { ReviewAndInstall } from './ReviewAndInstall';
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line max-lines-per-function
export const TwoClickAppInstallFocusedTask = _ref => {
  let {
    handleFocusedTaskClose,
    baseData,
    appInstallConfig,
    appKey,
    onInstallClick,
    isInstallInProgress
  } = _ref;
  const {
    result: baseDataResult,
    pending: baseDataPending,
    error: baseDataError
  } = baseData;
  const installMode = baseDataResult === null || baseDataResult === void 0 ? void 0 : baseDataResult.installMode;
  if (installMode && ![INSTALLABLE_APP_DEFAULT_INSTALL_MODE].includes(installMode.type)) {
    throw new Error("TwoClickAppInstall: Unhandled installMode received ".concat(installMode.type));
  }
  const [currentStep, setCurrentStep] = useState(0);
  const handleOnClose = () => {
    setCurrentStep(0);
    handleFocusedTaskClose();
  };
  const handleCancelButtonClick = () => {
    if (currentStep <= 0) {
      handleFocusedTaskClose();
    } else {
      setCurrentStep(currentStep - 1);
    }
  };
  const handleReviewButtonClick = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };
  const resolveInstallationCTA = () => {
    // This condition is met only while the data is loading, and we do not display the CTA until the data is fetched. This serves as a fallback.
    if (!installMode) {
      return 'Loading';
    }
    const {
      installableApp
    } = installMode;
    return resolveInstallationCTALabel({
      isFreeApp: isFreeApp(installableApp.marketplaceAppDetails.paymentModel),
      isCloudMigrationTrialEligible: !!installableApp.cloudMigrationTrial.isEligible,
      isEligibleForFreeOnSandbox: !!installableApp.eligibleForFreeOnSandbox
    });
  };
  const resolveSiteSelectionScreenContent = () => {
    if (baseDataPending) {
      return /*#__PURE__*/_jsx(TwoClickAppInstallLoading, {});
    }
    if (baseDataError) {
      return /*#__PURE__*/_jsx(TwoClickAppInstallError, {});
    }
    return /*#__PURE__*/_jsx("div", {
      children: "Select a site dummy content"
    });
  };
  const handleInstallButtonClick = () => {
    onInstallClick(baseDataResult.appIdentifier);
  };
  const steps = [_objectSpread({
    id: 'select-a-site-step',
    label: 'Select a site',
    type: 'progress',
    content: resolveSiteSelectionScreenContent(),
    contentSize: 'large'
  }, baseDataPending || baseDataError ? {} : {
    backButtonText: 'Cancel',
    backButtonOnClick: handleCancelButtonClick,
    nextButtonText: 'Review',
    nextButtonOnClick: handleReviewButtonClick
  }), _objectSpread({
    id: 'review-and-install-step',
    label: 'Review and install',
    type: 'progress',
    content: /*#__PURE__*/_jsx(ReviewAndInstall, {
      baseData: baseDataResult,
      appInstallConfig: appInstallConfig,
      appKey: appKey
    }),
    contentSize: 'large'
  }, baseDataPending || baseDataError ? {} : {
    backButtonText: 'Back',
    backButtonOnClick: handleCancelButtonClick,
    nextButtonText: resolveInstallationCTA(),
    nextButtonOnClick: handleInstallButtonClick,
    isSubmissionLoading: isInstallInProgress()
  })];
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    boundaryName: "TwoClickAppInstall",
    fallback: /*#__PURE__*/_jsx(FocusedTaskErrorBoundaryFallback, {
      isOpen: true,
      onClose: handleOnClose
    }),
    children: /*#__PURE__*/_jsx(IntlProvider, {
      locale: "en",
      children: /*#__PURE__*/_jsx(FocusedTask, {
        testId: TEST_IDS.TWO_CLICK_APP_INSTALL_PRODUCT_FOCUSED_TASK,
        currentStep: currentStep,
        isOpen: true,
        steps: steps,
        onClose: handleOnClose
      })
    })
  });
};